import axios from "../../../../api/axios";
import { User, PaginatedResponse } from "../../../../types/types";

export const getUserFollowers = async (userId: string, params?: string): Promise<PaginatedResponse<User>> => {
  try {
    const response = await axios.get(`/users/${userId}/followers${params || ""}`);
    return response.data.data;
  } catch (error) {
    throw new Error(`Failed to fetch user followers: ${error}`);
  }
};

export const getUserFollowing = async (userId: string, params?: string): Promise<PaginatedResponse<User>> => {
  try {
    const response = await axios.get(`/users/${userId}/following${params || ""}`);
    return response.data.data;
  } catch (error) {
    throw new Error(`Failed to fetch user following: ${error}`);
  }
};

export const getUserNetwork = async (userId: string, params?: string): Promise<PaginatedResponse<User>> => {
  try {
    const response = await axios.get(`/users/${userId}/network/v1${params || ""}`);
    return response.data.data;
  } catch (error) {
    throw new Error(`Failed to fetch user network: ${error}`);
  }
};
